import { BaseOption } from 'ui/selects';
import { SelectOption } from 'modules/queryBuilder/contexts/visualComponents';
import { SelectValueType } from 'ui/selects';
import { doesExist } from 'utils/tsHelpers';
import { convertToBaseOptions } from './convertToBaseOptions';
import { convertOptionsToMappings } from './convertOptionsToMappings';

/** Helper function to create default values array */
const createDefaultValues = <TValue extends SelectValueType>(
  value: TValue | null,
  selectedValue: SelectOption<TValue> | undefined,
) => {
  const inputtedValues = value ? [value] : [];
  return doesExist<TValue>(selectedValue?.value) ? [selectedValue.value] : inputtedValues;
};

/** Gets variables needed for selects */
export const getSelectVariables = <TValue extends SelectValueType = string>(
  value: TValue | null,
  options: SelectOption<TValue>[],
  isVirtualized?: boolean,
): {
  selectedValue: SelectOption<TValue> | undefined;
  defaultValues: TValue[];
  baseOptions: BaseOption<TValue>[];
  selectedBaseOption: BaseOption<TValue>[];
} => {
  // Use mappings for lookup when virtualized for improved peformance
  if (isVirtualized) {
    const { baseOptionsMapping, optionsMapping } = convertOptionsToMappings(options);
    const selectedValue = optionsMapping[value as string];
    const selectedBaseOption = value ? [baseOptionsMapping[value as string]] : [];
    const defaultValues = createDefaultValues(value, selectedValue);

    return {
      selectedValue,
      defaultValues,
      baseOptions: Object.values(baseOptionsMapping),
      selectedBaseOption,
    };
  }

  const baseOptions = convertToBaseOptions(options);
  const selectedValue = options.find(({ value: optionValue }) => value === optionValue);
  const selectedBaseOption = baseOptions.filter(({ value: baseValue }) => value === baseValue);
  const defaultValues = createDefaultValues(value, selectedValue);

  return {
    selectedValue,
    defaultValues,
    baseOptions,
    selectedBaseOption,
  };
};
